export default {
	title: 'Analysis Toolkit Configuration',
	subtitle: 'Configure and manage graph analysis tools',
	actions: {
		add: 'Add Tool',
		edit: 'Edit',
		delete: 'Delete',
		save: 'Save',
		cancel: 'Cancel',
		confirm: 'Confirm',
		clear: 'Clear',
		addNow: 'Add Now'
	},
	messages: {
		deleteConfirm: 'Are you sure you want to delete this tool?',
		deleteSuccess: 'Deleted successfully',
		saveSuccess: 'Saved successfully',
		updateSuccess: 'Updated successfully',
		selectDeleteWarning: 'Please select the records to delete',
		requiredFieldCannotBeEmpty: 'Required field cannot be empty',
		nameLengthRange: 'Configuration name length should be between 1-50 characters',
		atLeastOneTool: 'Please select at least one tool',
		clearedAllSelections: 'All selections have been cleared',
		confirmClearSelections: 'Are you sure you want to clear all selected tools?'
	},
	labels: {
		basicInfo: 'Basic Information',
		name: 'Name',
		remark: 'Description',
		selectedTools: 'Selected Tools',
		availableTools: 'Available Tools',
		noSelectedTools: 'No configured tools',
		noConfiguredTools: 'No configured tools',
		configName: 'Configuration Name',
		configDescription: 'Configuration Description'
	},
	placeholder: {
		name: 'Please enter configuration name',
		remark: 'Please enter configuration description',
		configName: 'Please enter configuration name'
	},
	status: {
		loading: 'Loading data...',
		noDataTitle: 'No Tool Configuration',
		noDataDesc: 'You have not configured any analysis tools yet. Click "Add Tool" button above to start configuring',
		saving: 'Saving...'
	},
	dialog: {
		editTitle: 'Edit Tool',
		addTitle: 'Add Tool',
		deleteConfirmTitle: 'Delete Confirmation'
	}
}
